function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgIotedge(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    id: "iotedge_svg__\u56FE\u5C42_1",
    "data-name": "\u56FE\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    width: "1em",
    height: "1em",
    "uc-svg": "www"
  }, props), React.createElement("defs", null, React.createElement("style", null, '.iotedge_svg__cls-1{fill:#091f42}')), React.createElement("path", {
    className: "iotedge_svg__cls-1",
    d: "M77.51 7.52a4 4 0 00-4-3.52H22.46a4 4 0 00-4 3.52l-6.21 51.42a.42.42 0 00.75.29 3.88 3.88 0 013-1.47h64a3.85 3.85 0 013 1.48.42.42 0 00.75-.3zM44 41.92a2 2 0 01-2 2h-2a2 2 0 01-2-2v-15L34.93 30a2 2 0 01-2.83 0l-1.41-1.42a2 2 0 010-2.83l8.21-8.21a3 3 0 013.78-.38 3.15 3.15 0 011.32 2.7zm21.31-7.09L57.11 43a3 3 0 01-3.78.38A3.17 3.17 0 0152 40.77V18.7a2 2 0 012-2h2a2 2 0 012 2v15l3.1-3.09a2 2 0 012.82 0L65.33 32a2 2 0 010 2.83zM80 66H16a4 4 0 00-4 4v18a4 4 0 004 4h64a4 4 0 004-4V70a4 4 0 00-4-4zM28 84a5 5 0 115-5 5 5 0 01-5 5zm20 0a5 5 0 115-5 5 5 0 01-5 5zm20 0a5 5 0 115-5 5 5 0 01-5 5z"
  }));
}

SvgIotedge.clsName = 'icon-www__iotedge';
SvgIotedge.remarkName = 'unknown';
export default SvgIotedge;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Iotedge.js
// module id = 2366
// module chunks = 17 18